import Service from '../Service';
import { ResponseErrorBody } from '../../types';
import Request from '../Request';
import { addFingerprintToRequest } from './utils';

export default async function() {
  const request = await addFingerprintToRequest(
    new Request<any>('/api/auth/logout').setMethod('POST')
  );
  const service = new Service<any, ResponseErrorBody>(request);
  return await service.send();
}
